import React,{useEffect} from 'react'
import { useSearchParams } from 'react-router-dom';

const Payment = () => {
    const [searchParams] = useSearchParams();
    const payUrl = searchParams.get("payUrl");

    useEffect(() => {
        if (payUrl) {
            window.location.href = payUrl; // Redirect to PhonePe payment page
        }
    }, [payUrl]);
  return (
    <div>Payment</div>
  )
}

export default Payment